import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import Layout from "./components/Layout";
import LoginPage from "./pages/Login";
import VerifyPage from "./pages/Verify";
import HomePage from "./pages/Home";
import TurnsPage from "./pages/Turns";
import CalendarPage from "./pages/Calendar";
import LibraryPage from "./pages/Library";
import AddBookPage from "./pages/AddBook";
import MembersPage from "./pages/Members";
import MemberDetailPage from "./pages/MemberDetail";
import ProfilePage from "./pages/Profile";
import BookDetailPage from "./pages/BookDetail";
import RecommendationsPage from "./pages/Recommendations";
import QuotesPage from "./pages/Quotes";
import RecipesPage from "./pages/Recipes";
import InsightsPage from "./pages/Insights";
import MeetingPacketPage from "./pages/MeetingPacket";
import MeetingRoomPage from "./pages/MeetingRoom";
import { Spinner } from "./components/ui";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/verify" element={<VerifyPage />} />
        <Route element={<RequireAuth />}>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="/turns" element={<TurnsPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/meetings/:id/packet" element={<MeetingPacketPage />} />
            <Route path="/meetings/:id/room" element={<MeetingRoomPage />} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/add-book" element={<AddBookPage />} />
            <Route path="/members" element={<MembersPage />} />
            <Route path="/members/:id" element={<MemberDetailPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/book/:id" element={<BookDetailPage />} />
            <Route path="/recommendations" element={<RecommendationsPage />} />
            <Route path="/notebook" element={<Navigate to="/notebook/quotes" replace />} />
            <Route path="/notebook/quotes" element={<QuotesPage />} />
            <Route path="/notebook/recipes" element={<RecipesPage />} />
            <Route path="/insights" element={<InsightsPage />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}

function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-rose">
        <Spinner size={28} />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
